import {RestApiService} from '../../../rest-api.service';
import {ApiV0} from '../../api.v0';

export class ApiV0BankAccount{
    segment = '/bankAccounts'
    constructor(v0:ApiV0, private rest:RestApiService) {
        this.segment = v0.segment + this.segment;
    }

    delete(ids:string[]) {
        return this.rest.delete<void>(this.segment, {}, ids);
    }
}